<!--手机号验证码-->
<template>
  <div class="item-box">
    <!--标题-->
    <div :class="['question-item-title',{isMbottom:question.show_rule.is_check_show}]">
      <span>
        <i v-if="!$store.state.settingData.base.notorder">{{ number }}、</i>
        <span class="q-title" v-html="question.title"></span>
        <Icon type="ios-information-circle" @click="hintShowClick" v-if="question.show_rule.is_check_show && question.show_rule.hint.length>0"/>
      </span>
    </div>
    <span class="title-tips" v-html="question.show_rule.hint" v-if="!question.show_rule.is_check_show"></span>
    <div class="q-content">
      <Input size="large"
             type="text"
             v-model="tel"
             placeholder="请输入手机号">
        <i class="iconfont iconshouji1" slot="prepend"></i>
      </Input>
      <Input class="captchaInput" size="large" type="text" v-model="captcha" placeholder="请输入图形验证码">
        <Icon class="captcha" type="ios-lock-outline" slot="prepend"/>
          <div class="captchaImg" slot="append" @click="updataCaptchImg">
            <img :src="captchaData.img" alt="" v-if="isImg">
            <Icon class="imgNone" type="ios-image-outline" v-else/>
        </div>
      </Input>
      <Input size="large"
             class="yzm"
             type="text"
             v-model="code"
             @on-blur="telCodeBlur"
             placeholder="请输入验证码">
        <i class="iconfont iconyanzheng" slot="prepend"></i>
        <div class="btn" slot="append" v-show="show" @click="getCode">
          <i class="iconfont iconxiaoxi1"></i>
          <span>获取验证码</span>
        </div>
        <div class="btn" slot="append" v-show="!show">{{count}}S后重新获取</div>
      </Input>
    </div>
    <!--提示弹框-->
    <Modal class="hintModel" v-model="modal" width="70%" :closable="false">
      <p slot="header">
        <Icon type="ios-information-circle"></Icon>
        <span>填写提示</span>
      </p>
      <div style="color: #4e4c56;font-size: 16px">
        <span v-html="question.show_rule.hint"></span>
      </div>
      <div slot="footer">
        <p @click="clearClick">我知道了</p>
      </div>
    </Modal>
  </div>
</template>

<script>
    import {mobileCode, mobileCheck, getCaptcha} from "../../api/Interface";

    const TIME_COUNT = 60;
    export default {
        name: "tTelCode",
        props: {
            question: {
                type: Object,
                default() {
                    return {}
                }
            },
            number: {
                type: Number,
                default() {
                    return 1;
                }
            },
        },
        data() {
            return {
                tel: '',
                code: '',
                show: true,
                count: '',
                timer: null,
                modal: false,
                captcha:'',
                captchaData:{},
                isImg:false
            }
        },
        mounted() {
            this.tel = this.$store.state.user_answers[this.question.id]
            this.getCaptchaData();
        },
        methods: {
          //获取图形验证码
          getCaptchaData() {
            getCaptcha().then(res => {
              if (res.state) {
                this.isImg = true
                this.captchaData = res.data
              } else {
                this.$Message.error('图形验证码获取失败')
              }
            }).catch(error => {
              console.log(error);
            })
          },
          updataCaptchImg(){
            this.getCaptchaData();
          },
            //获取验证码
            getCode() {
                if ((/^1[3456789]\d{9}$/.test(this.tel))) {
                    let data = {
                        mobile: this.tel,
                        form_id: this.$store.state.formId,
                        captcha:this.captcha,
                        key:this.captchaData.key
                    }
                    mobileCode(data).then(res => {
                        if (!res.state) {
                            this.$Message.error(res.error);
                        }
                    }).catch(error => {
                        console.log(error);
                    })
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.show = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                } else {
                    this.$Message.error('请先输入正确的手机号');
                }
            },
            telCodeBlur() {
                let requestData = {
                    form_id: this.$store.state.formId,
                    mobile: this.tel,
                    code: this.code
                }
                if (this.code.length === 6) {
                    mobileCheck(requestData).then(res => {
                        if (res.state) {
                            let obj = {}
                            obj[this.question.id] = this.tel
                            this.$store.dispatch('userAnswersActions', obj)
                        } else {
                            this.$Message.error(res.error);
                        }
                    }).catch(error => {
                        console.log(error);
                    })
                } else {
                    this.$Message.warning('请输入6位数验证码')
                }
            },
            hintShowClick() {
                this.modal = true
            },
            clearClick() {
                this.modal = false
            }
        }

    }
</script>

<style lang="scss" scoped>
  .q-content {
    .btn {
      display: flex;
      color: #3559E0;
      align-items: center;
      font-size: 12px;
      border-left: 1px solid #D2D6EB;
      padding-left: 10px;

      .iconfont {
        font-size: 18px !important;
        margin-right: 5px;
      }

      &:hover {
        cursor: pointer;
      }
    }


    .ivu-input-group {
      margin-bottom: 20px;

      /deep/ .ivu-input-group-prepend {
        background-color: transparent;
      }

      /deep/ .ivu-input {
        /*height: 45px;*/
        border-left: none !important;
        outline: none !important;
        -webkit-appearance: none; /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/

        &:focus {
          box-shadow: none;
          border-color: #dcdee2;
        }
      }

      .iconfont {
        font-size: 22px;
      }

      /deep/ .ivu-input-group-append {
        background-color: transparent;
        border-left: none !important;
      }
    }

    .yzm {
      /deep/ .ivu-input {
        border-right: none !important;
      }
    }

    .captchaImg {
      width: 60px;
      padding: 0 3px;
      box-sizing: content-box;
        img {
          width: 100%;
        }
    }

    .captchaInput {
      /deep/ .ivu-input-group-append {
      padding: 0 !important;
    }
  }
  .captcha {
    font-size: 22px;
    color: #515a6e !important;
  }

  }
</style>
